/* Components */
import Vue from 'vue';

import playorpause from './playorpause.vue';
Vue.component('playorpause', playorpause);

import arrow from './arrow.vue';
Vue.component('arrow', arrow);

import miniarrow from './miniarrow.vue';
Vue.component('miniarrow', miniarrow);

import logo from './logo.vue';
Vue.component('logo', logo);

import monogram from './monogram.vue';
Vue.component('monogram', monogram);

import backtotop from './backtotop.vue';
Vue.component('backtotop', backtotop);

import feature from './feature.vue';
Vue.component('feature', feature);

import categories from './categories.vue';
Vue.component('categories', categories);
